import { ReactElement } from "react";
import AccountMenu from "../components/shared/Menu";
import MainPage from "../components/mainPage/MainPage"

const LandingPage = (): ReactElement => {

    return <>
        <AccountMenu />
        <MainPage />
    </>
}

export default LandingPage;